import React, { useState } from 'react';
import { ShoppingBag } from 'lucide-react';
import { authAPI } from '../services/api';
import { toast } from 'react-toastify';

export function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault(); // ⭐ THIS MUST BE FIRST - prevents page reload
    e.stopPropagation(); // Also stop event bubbling
    
    console.log('🔐 Login attempt started');
    console.log('Username:', username);
    console.log('Password length:', password.length);
    
    setLoading(true);

    try {
      console.log('📡 Calling API...');
      const response = await authAPI.login({ username, password });
      
      console.log('📥 Response received:', response);
      console.log('📦 Response data:', response.data);
      
      if (response.data && response.data.success && response.data.token) {
        console.log('✅ Token received:', response.data.token);
        toast.success('Login successful!');
        onLogin(response.data.token);
      } else {
        console.error('❌ No token in response');
        toast.error('Login failed - no token received');
        setLoading(false);
      }
    } catch (error) {
      console.error('❌ Login error:', error);
      console.error('Error details:', error.response?.data);
      toast.error(error.response?.data?.error || 'Login failed - check console');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-600 via-purple-600 to-pink-500">
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-600 to-purple-600 rounded-full mb-4">
            <ShoppingBag className="text-white" size={32} />
          </div>
          <h2 className="text-3xl font-bold text-gray-800">Welcome Back</h2>
          <p className="text-gray-600 mt-2">Sign in to your account</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Enter username"
              required
              autoComplete="username"
            />
          </div>

          <div className="mb-6">
            <label className="block text-gray-700 font-medium mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Enter password"
              required
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-purple-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p className="text-center text-gray-600 text-sm mt-6">
          Default: admin / admin123
        </p>
      </div>
    </div>
  );
}

export default Login;